function parsePayloadForQuery(payload) {
  let queryParams = '';
  if (payload) {
    const keys = Object.keys(payload);
    for (const k of keys) {
      queryParams += `&${k}=${encodeURIComponent(payload[k])}`;
    }
  }
  return queryParams;
}

export {
  parsePayloadForQuery
};
